import React from 'react';
import { FadeIn } from './FadeIn';
export function SolutionOverview() {
  return <section className="pt-4 pb-2 px-3 max-w-3xl mx-auto" data-id="element-272">
      <FadeIn className="text-center mb-4" data-id="element-273">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 md:px-5 md:py-2 rounded-full border-2 border-accent/40 bg-accent/10 mb-2 whitespace-nowrap" data-id="element-274">
          <span className="text-lg md:text-xl" data-id="element-275">🏆</span>
          <h2 className="font-display text-sm md:text-xl lg:text-2xl font-bold text-accent" data-id="element-276">
            Sistema Clínico N°1 para nutricionistas
          </h2>
        </div>
      </FadeIn>
    </section>;
}